var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m104.407 459.477c41.706 32.892 94.356 52.523 151.593 52.523 28.914 0 56.653-5.024 82.407-14.221l122-95.694c25.646-38.728 40.595-85.159 40.595-135.087 0-135.311-109.691-245.003-245.002-245.003s-245.002 109.692-245.002 245.003c0 64.749 25.129 123.62 66.152 167.425z",
    fill: "#1c2e7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m449.921 292.035h-89.486c-6.347 0-11.54 5.193-11.54 11.54v11.549c0 6.347 5.193 11.54 11.54 11.54h89.486z",
    fill: "#e9efff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m385.395 309.349c0-9.523 7.791-17.314 17.314-17.314h-42.274c-6.347 0-11.54 5.193-11.54 11.54v11.549c0 6.347 5.193 11.54 11.54 11.54h42.274c-9.523-.001-17.314-7.792-17.314-17.315z",
    fill: "#bec8f7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m449.921 334.163h-89.486c-10.499 0-19.04-8.542-19.04-19.04v-11.548c0-10.499 8.542-19.04 19.04-19.04h89.486c4.142 0 7.5 3.358 7.5 7.5s-3.358 7.5-7.5 7.5h-89.486c-2.19 0-4.04 1.85-4.04 4.04v11.548c0 2.19 1.85 4.04 4.04 4.04h89.486c4.142 0 7.5 3.358 7.5 7.5s-3.358 7.5-7.5 7.5z",
    fill: "#38c674"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m383.394 326.663c0-4.142 3.358-7.5 7.5-7.5h-30.459c-2.191 0-4.041-1.85-4.041-4.04v-11.548c0-2.19 1.85-4.04 4.041-4.04h30.459c-4.142 0-7.5-3.358-7.5-7.5s3.358-7.5 7.5-7.5h-30.459c-10.499 0-19.041 8.542-19.041 19.04v11.548c0 10.499 8.542 19.04 19.041 19.04h30.459c-4.142 0-7.5-3.358-7.5-7.5z",
    fill: "#24b55e"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m102.408 358.884h238v27.258h-238z",
    fill: "#d3dcfb"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m289.271 358.884c6.078 1.563 10.575 7.063 10.575 13.629 0 6.565-4.498 12.066-10.575 13.629h51.137v-27.258z",
    fill: "#bec8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.149 434.422c8.442 9.015 17.549 17.398 27.258 25.055v-100.593h-27.258z",
    fill: "#e9efff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.096 144.297h231.12v117.961h-231.12z",
    fill: "#ff4155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.096 262.258h85.8c.501-1.163.478-2.513-.084-3.708-4.885-10.384 2.603-15.911 6.516-17.979 1.343-.71 2.205-2.081 2.3-3.598l4.207-67.417c.107-1.716-.811-3.312-2.313-4.15-8.373-4.677-7.551-12.186-6.31-16.259.506-1.66.049-3.486-1.273-4.609-.094-.079-.17-.161-.26-.24h-88.583z",
    fill: "#e80054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m239.157 310.745-2.601-19.408h-43.799l-2.601 19.408c-1.331 9.929-7.695 14.82-8.402 15.785-2.639 2.762-.681 7.339 3.138 7.339h59.528c3.82 0 5.777-4.578 3.138-7.339-.678-.926-7.076-5.897-8.401-15.785z",
    fill: "#d3dcfb"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m207.768 320.853.97-9.699c.551-5.511 5.189-9.708 10.729-9.708h18.444l-1.355-10.108h-43.799l-2.601 19.408c-1.331 9.929-7.695 14.82-8.401 15.785-2.639 2.762-.682 7.339 3.138 7.339h18.538c1.61-2.538 3.713-6.784 4.337-13.017z",
    fill: "#bec8f7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m99.096 261.319v14.94c0 8.831 7.185 16.016 16.016 16.016h199.089c8.831 0 16.015-7.185 16.015-16.016v-14.94z",
    fill: "#e9efff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.174 261.319h-86.078v14.94c0 8.831 7.185 16.016 16.016 16.016h68.317c.458-1.308.322-2.812-.574-4.038-8.386-11.472-2.346-20.786 1.285-24.794.555-.612.893-1.349 1.034-2.124z",
    fill: "#d3dcfb"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m330.216 335.625v-13.458c0-5.429-4.442-9.871-9.871-9.871h-18.655c-5.429 0-9.871 4.442-9.871 9.871v13.458z",
    fill: "#d3dcfb"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m314.201 124.833h-199.089c-8.831 0-16.016 7.184-16.016 16.016v5.449h231.12v-5.449c0-8.832-7.184-16.016-16.015-16.016z",
    fill: "#e80054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m187.938 144.537c-6.248-5.305-5.226-11.536-3.511-15.548.607-1.422.399-2.968-.388-4.156h-68.927c-8.831 0-16.016 7.184-16.016 16.016v5.449h90.045c-.242-.669-.638-1.281-1.203-1.761z",
    fill: "#cc0053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m393.1 103.608c-17.517 2.374-30.852 17.916-29.708 36.33 1.065 17.153 15.026 31.114 32.18 32.178 18.414 1.143 33.955-12.192 36.329-29.708.336-2.477-1.644-4.669-4.144-4.669h-25.82c-2.302 0-4.168-1.866-4.168-4.168v-25.82c-.001-2.499-2.192-4.479-4.669-4.143z",
    fill: "#ffdd40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m414.991 90.523v25.826c0 2.302 1.866 4.168 4.168 4.168h25.826c2.487 0 4.474-2.171 4.142-4.635-2.06-15.315-14.185-27.44-29.501-29.501-2.464-.332-4.635 1.655-4.635 4.142z",
    fill: "#ffe98d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m317.464 91.964h-53.921c-7.014 0-12.752-5.738-12.752-12.752v-44.83c0-7.014 5.738-12.752 12.752-12.752h53.921c7.014 0 12.752 5.738 12.752 12.752v44.829c0 7.014-5.738 12.753-12.752 12.753z",
    fill: "#ffdd40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.792 34.382v44.829c0 7.014 5.739 12.752 12.752 12.752h36.379c-.024-.953-.322-1.905-.912-2.723-5.002-6.932-2.314-13.009.046-16.3 1.179-1.644 1.21-3.854.029-5.497-13.045-18.15-4.231-35.792.175-42.554.643-.986.878-2.146.727-3.26h-36.444c-7.014.001-12.752 5.74-12.752 12.753z",
    fill: "#ffb332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m339.156 70.333h-53.921c-7.014 0-12.752-5.738-12.752-12.752v-44.829c0-7.014 5.738-12.752 12.752-12.752h53.921c7.014 0 12.752 5.738 12.752 12.752v44.829c0 7.014-5.739 12.752-12.752 12.752z",
    fill: "#fc90ce"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300.082 0h-14.847c-7.014 0-12.752 5.738-12.752 12.752v44.829c0 7.014 5.738 12.752 12.752 12.752h14.71c.038-1.01-.239-2.028-.858-2.889-13.045-18.15-4.231-35.792.175-42.554 1.095-1.68 1.042-3.87-.178-5.461-5.958-7.771-2.644-14.047.003-17.206.545-.65.868-1.421.995-2.223z",
    fill: "#f964b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m317.464 21.63h-44.981v35.951c0 7.014 5.738 12.752 12.752 12.752h44.981v-35.951c0-7.013-5.738-12.752-12.752-12.752z",
    fill: "#f964b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m299.087 67.444c-13.045-18.15-4.231-35.792.175-42.554.643-.986.878-2.146.727-3.26h-27.505v35.951c0 7.014 5.738 12.752 12.752 12.752h14.71c.037-1.01-.24-2.028-.859-2.889z",
    fill: "#ea349c"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m158.724 92.622c-4.142 0-7.5-3.358-7.5-7.5v-18.158c0-4.142 3.358-7.5 7.5-7.5s7.5 3.358 7.5 7.5v18.158c0 4.142-3.357 7.5-7.5 7.5z",
    fill: "#9bd8f9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m184.261 92.622c-4.142 0-7.5-3.358-7.5-7.5v-31.577c0-4.142 3.358-7.5 7.5-7.5s7.5 3.358 7.5 7.5v31.577c0 4.142-3.358 7.5-7.5 7.5z",
    fill: "#73c3f9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m209.798 92.622c-4.142 0-7.5-3.358-7.5-7.5v-44.997c0-4.142 3.358-7.5 7.5-7.5s7.5 3.358 7.5 7.5v44.997c0 4.142-3.358 7.5-7.5 7.5z",
    fill: "#4fabf7"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 214.656,
    cy: 204.277,
    fill: "#e9efff",
    r: 41.19
  }), /*#__PURE__*/React.createElement("path", {
    d: "m460.408 402.085v-41.98h-122v51.118h115.646c2.184-2.996 4.303-6.042 6.354-9.138z",
    fill: "#e9efff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.346 372.884c0-6.6 5.4-12 12-12h72.062v-.779h-122v51.118h37.938z",
    fill: "#d3dcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.408 411.223v51.118h65.468c19.116-14.493 36.033-31.728 50.178-51.118z",
    fill: "#d3dcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.407 411.223h37.938v51.118h-37.938z",
    fill: "#bec8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m403.875 462.34h-65.468v35.438c23.727-8.472 45.762-20.497 65.468-35.438z",
    fill: "#e9efff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.346 468.06v-5.719h-37.938v35.438c14.98-5.35 29.284-12.118 42.755-20.14-2.915-2.195-4.817-5.671-4.817-9.579z",
    fill: "#d3dcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m470.753 333.625h-405.22c-7.527 0-13.629 6.102-13.629 13.629s6.102 13.629 13.629 13.629h405.22c7.527 0 13.629-6.102 13.629-13.629s-6.102-13.629-13.629-13.629z",
    fill: "#3c58a0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.991 347.254c0-7.527 6.102-13.629 13.629-13.629h-128.088c-7.527 0-13.629 6.102-13.629 13.629s6.102 13.629 13.629 13.629h128.088c-7.527.001-13.629-6.101-13.629-13.629z",
    fill: "#2a428c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221.561 276.797c0 3.813-3.091 6.904-6.904 6.904s-6.904-3.091-6.904-6.904 3.091-6.904 6.904-6.904c3.812 0 6.904 3.091 6.904 6.904z",
    fill: "#bec8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.532 59.38h-22.918c0 20.848 16.901 37.75 37.75 37.75-8.192 0-14.832-16.901-14.832-37.75z",
    fill: "#73c3f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.196 59.38c0 20.848-6.641 37.75-14.832 37.75 20.849 0 37.75-16.901 37.75-37.75z",
    fill: "#73c3f9"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#9bd8f9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m102.196 59.38h-29.664c0 20.848 6.641 37.75 14.832 37.75s14.832-16.901 14.832-37.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.364 21.63c8.192 0 14.832 16.901 14.832 37.75h22.918c0-20.848-16.901-37.75-37.75-37.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.532 59.38c0-20.849 6.641-37.75 14.832-37.75-20.849 0-37.75 16.901-37.75 37.75z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m87.364 21.63c-8.192 0-14.832 16.901-14.832 37.75h29.664c0-20.848-6.64-37.75-14.832-37.75z",
    fill: "#73c3f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219.324 214.472-13.764-26.606c-14.785-4.098-7.542-21.267-7.542-21.269-14.458 6.394-24.552 20.854-24.552 37.68 0 22.749 18.441 41.19 41.19 41.19 6.845 0 13.294-1.679 18.973-4.633-22.936-4.383-14.305-26.362-14.305-26.362z",
    fill: "#d3dcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.791 201.109-23.119-13.029c-2.424-1.366-5.423.385-5.423 3.168v26.059c0 2.783 2.998 4.535 5.423 3.168l23.119-13.029c2.469-1.391 2.469-4.946 0-6.337z",
    fill: "#ff4155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m401.936 137.739c-2.302 0-4.168-1.866-4.168-4.168v-25.82c0-2.5-2.191-4.479-4.669-4.144-17.517 2.374-30.852 17.916-29.708 36.33 1.065 17.153 15.026 31.114 32.18 32.178 2.089.13 4.138.064 6.138-.164-19.665-19.93.227-34.212.227-34.212z",
    fill: "#ffb332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m449.921 243.406h-89.486c-6.347 0-11.54 5.193-11.54 11.54v11.549c0 6.347 5.193 11.54 11.54 11.54h89.486z",
    fill: "#e9efff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m385.395 260.721c0-9.523 7.791-17.314 17.314-17.314h-42.274c-6.347 0-11.54 5.193-11.54 11.54v11.549c0 6.347 5.193 11.54 11.54 11.54h42.274c-9.523-.001-17.314-7.793-17.314-17.315z",
    fill: "#bec8f7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m449.921 285.535h-89.486c-10.499 0-19.04-8.542-19.04-19.04v-11.549c0-10.499 8.542-19.04 19.04-19.04h89.486c4.142 0 7.5 3.358 7.5 7.5s-3.358 7.5-7.5 7.5h-89.486c-2.19 0-4.04 1.85-4.04 4.04v11.549c0 2.19 1.85 4.04 4.04 4.04h89.486c4.142 0 7.5 3.358 7.5 7.5s-3.358 7.5-7.5 7.5z",
    fill: "#ffc839"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m383.394 278.035c0-4.142 3.358-7.5 7.5-7.5h-30.459c-2.191 0-4.041-1.85-4.041-4.04v-11.549c0-2.189 1.85-4.04 4.041-4.04h30.459c-4.142 0-7.5-3.358-7.5-7.5s3.358-7.5 7.5-7.5h-30.459c-10.499 0-19.041 8.541-19.041 19.04v11.549c0 10.498 8.542 19.04 19.041 19.04h30.459c-4.142 0-7.5-3.358-7.5-7.5z",
    fill: "#ffb332"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesk);
export default __webpack_public_path__ + "static/media/desk.8722ea0b.svg";
export { ForwardRef as ReactComponent };